<template>
  <page-content>
    <edit-field-header
      :title="title"
      @routerBack="$router.back()"
    />

    <edit-field
      :is-edit="true"
      :fields="fields"
      :row-data="row_data"
      post-api="/bemonitor/AssignMonitor"
      finish-router="bedexitenvironment"
      permission="Mon_Menu_Environment"
    >
    </edit-field>
  </page-content>
</template>

<script>
import fields from "@/views/bedExitMonitor/deviceEnv/fields";
import EditField from "@/components/EditField";
import EditFieldHeader from "@/components/EditFieldHeader";
import common from "@/common";
import PageContent from "@/components/PageContent";

export default {
  name: "Edit",
  components: {
    PageContent,
    EditFieldHeader,
    EditField,
    fields
  },
  data() {
    return {
      title: common.getMenuName('bedexitenvironment') + ' - ' + common.getI18n('common.edit'),
      fields,
      row_data: {
        deviceMAC: this.$router.currentRoute.params.mac,
        isUAT: this.$router.currentRoute.params.env,
      }
    }
  },
  mounted() {
    this.row_data.deviceMAC = common.decrypt(this.row_data.deviceMAC)
    this.row_data.isUAT = common.decrypt(this.row_data.isUAT)
    if ([this.row_data.deviceMAC, this.row_data.isUAT].includes(undefined)) {
      this.$router.push({ path: '/' + this.$route.path.split('/')[1] })
      return false
    }
  }
}
</script>

<style scoped>

</style>
